import { render, staticRenderFns } from "./SecurityManagerDetails.vue?vue&type=template&id=24ee1ea6&scoped=true&"
import script from "./SecurityManagerDetails.vue?vue&type=script&lang=js&"
export * from "./SecurityManagerDetails.vue?vue&type=script&lang=js&"
import style0 from "./SecurityManagerDetails.vue?vue&type=style&index=0&id=24ee1ea6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ee1ea6",
  null
  
)

export default component.exports